/**
 * 메인 페이지 섹션용 스크롤 리빌 애니메이션 공통 variants.
 * - sectionStagger: 한 뷰포트에 함께 들어오는 타이트한 그룹(카드 2개·feature 3개·썸네일 3개 등)의 스태거 컨테이너.
 * - fadeUpItem: 개별 블록이 아래에서 위로 올라오며 블러가 걷히는 진입 모션.
 * - revealViewport: whileInView 공통 옵션 — `once: true` 로 한 번 재생 후 고정.
 *   `once: false` 로 매번 재생하면 IntersectionObserver 의 단일 threshold 특성상
 *   경계(네비바 하단·스크롤 턴어라운드 지점)에서 hidden↔visible 이 반복 토글되어
 *   두꺼운 타이포(BIIYEON/Aura/Work 등)가 떨리는 현상이 발생함. 재생을 한 번으로 고정해 제거.
 */

export const sectionStagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.22,
      delayChildren: 0.12,
    },
  },
};

export const fadeUpItem = {
  hidden: {
    opacity: 0,
    y: 56,
    filter: 'blur(12px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.68,
      ease: [0.2, 0.9, 0.25, 1],
    },
  },
};

/* once: true — 첫 진입 시 한 번만 재생해 경계 플리커를 원천 차단. amount: 0.25 — 블록 25% 진입 시 트리거. */
export const revealViewport = { once: true, amount: 0.25 };
